import React from 'react';
import styles from './TipAmountInput.module.css';

const TipAmountInput = ({ amount, setAmount, placeholder = "Enter the tip amount" }) => {

    const handleChange = (event) => {
        let value = event.target.value.replace(',', '.');
        value = value.replace(/[^0-9.]/g, '');
        if (value.includes('.')) {
            const parts = value.split('.');
            if (parts[1]?.length > 2) {
                value = `${parts[0]}.${parts[1].slice(0, 2)}`;
            }
        }

        const numericValue = parseFloat(value);

        if (!isNaN(numericValue)) {
            if (numericValue >= 1 && numericValue <= 999.99) {
                setAmount(value);
            }
        } else {
            setAmount('');
        }
    };


    return (
        <div className={styles.container}>
            <input
                type="text"
                value={amount ? `$${amount}` : ''}
                placeholder={placeholder}
                onChange={handleChange}
                inputMode="decimal"
                className={amount ? styles.filledInput : styles.emptyInput}
            />
        </div>
    );
};

export default TipAmountInput;
